// localStorage keys shared between the bo and bo_external
export const STORAGE_KEYS = {
  useLocalDeltaDb: 'use-local-delta-db',
  boDevAuthEmail: 'bo-dev-auth-email',
  deviceId: 'deviceId',
} as const;
